import { createSubscriptionsReducer } from '@/features/subscription/store';
import editorReducer from '@/features/content-library/store/editor.slice';
import userReducer from '@/features/user/user.slice';
import { api } from '@/services/api';
import { combineReducers } from '@reduxjs/toolkit';

export const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  user: userReducer,
  createSubscription: createSubscriptionsReducer,
  editor: editorReducer
});
